import React from "react";

/**
 * 상세 본문 3열 — 1열(요청정보) | 2열(진행·결재 등) | 3열(메모)
 * 상단 요약·진행단계(DetailProgressStatus) 아래에 배치
 */
export function ContentDetailThreeColLayout({primary, secondary, aside, className = ""}) {
    return (
        <div className={`detail-list-panel-grid-3 detail-list-v2-stack ${className}`.trim()}>
            <div className="detail-list-col">
                <div className="detail-list-col-scroll">{primary}</div>
            </div>
            <div className="detail-list-col">
                <div className="detail-list-col-scroll">{secondary}</div>
            </div>
            <div className="detail-list-col detail-list-col--memo">
                <div className="detail-list-col-scroll">{aside}</div>
            </div>
        </div>
    );
}
